export const types = {
  loadingListTrue: "[Status] Switching Loading Videos to True",
  loadingListFalse: "[Status] Switching Loading Videos to False",
  loadingMyListTrue: "[Status] Switching Loading MY Videos to True",
  loadingMyListFalse: "[Status] Switching Loading MY Videos to False",
  reset: "[Status] RESET",
};
